<template>
  <div>
    <div class=" ai_vehicle_info bg-white rounded_10 mb-4 custom_box_shadow" v-if="vehicleInfo">
      <div class="row">
        <div class="col-md-12">
          <h1 class="_theme_font_bold font-weight-bold mb-4">{{ vehicleDisplayName }}</h1>
        </div>
      </div>
      <div class="d-flex gap_60">
        <div class="">
          <div>

            <div class="mb-2">
              <p class="d-flex align-items-center">
                <span class="max_100"> Exterior : </span>
                <span v-if="vehicleInfo.extColorHexCode || vehicleInfo.ext_Color_Generic"
                  class="mr-2 color-box d-inline-block" :style="getVehicleIntExteriorColorStyle(
                    vehicleInfo.extColorHexCode,
                    vehicleInfo.ext_Color_Generic
                  )
                    ">
                </span>
                <span> {{ vehicleInfo.exteriorColor }}</span>
              </p>
              <p class="d-flex align-items-center">
                <span class="max_100"> Interior : </span>
                <span v-if="vehicleInfo.intColorHexCode || vehicleInfo.int_Color_Generic"
                  class="mr-2 color-box d-inline-block" :style="getVehicleIntExteriorColorStyle(
                    vehicleInfo.intColorHexCode,
                    vehicleInfo.int_Color_Generic
                  )
                    "></span>
                <span>{{ vehicleInfo.interiorColor }}</span>
              </p>
            </div>

            <div class="mb-3">
              <p class="mb-0">
                <small>VIN: {{ vehicleInfo.vin }}</small>
              </p>
              <p class="mb-0">
                <small> Stock #{{ vehicleInfo.stock }}</small>
              </p>
              <p class="mb-0">
                <small>Model Code: {{ vehicleInfo.modelNumber }}</small>
              </p>
            </div>


            <div v-if="isApiLoading">
              <SimmerEffect width="100%" />
              <SimmerEffect width="90%" />
              <SimmerEffect width="95%" />
              <SimmerEffect width="85%" />
              <SimmerEffect width="70%" />
            </div>

            <div v-if="msrpDetails" class="my-2 msrp_details_box">

              <div class="c_border p-3 border rounded_10" v-if="msrpDetails.slice(0, -1).length">

                <div v-for="(item, index) in msrpDetails.slice(0, -1)" :key="'main-' + index">
                  <div>
                    <div>
                      <p class="d-flex align-items-center  mb-1 justify-content-end">
                        <span class="max_100">{{ item.key }}</span>
                        <span class="p_x_60"></span>
                        <span v-if="item.value" class="ml-2 font-weight-bold flex-1 text-right">{{ item.value }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div>
                  <h1
                    class="d-flex align-items-center justify-content-between my-2 _theme_font_bold font-weight-bold custom_font_size">
                    <!-- <span class="max_100">{{ savingsData[savingsData.length - 1].key }}</span> -->
                    <span v-if="msrpDetails[msrpDetails.length - 1].value" class="_theme_font_bold font-weight-bold ">
                      {{ msrpDetails[msrpDetails.length - 1].value }}
                    </span>
                  </h1>
                </div>
              </div>
            </div>
            <div class="incentives_box">
              <total-incentive-discount v-if="qualifiedData && qualifiedData.length" type="vdp" :key="isLastIndex"
                :qualified-data="qualifiedData" :component="'ai_assistant'" :custom-header-label="customHeaderLabel" />
            </div>

            <!-- <div v-if="msrpDetails?.totalSavingsData" class="mt-3">
              <div v-for="(value, key) in msrpDetails.totalSavingsData" :key="key">
                <h4 class="d-flex align-items-center justify-content-between mb-2 font-weight-bold">
                  <span class="max_100">{{ key }}</span>
                  <span v-if="value" class="ml-2"> {{ value }} </span>
                </h4>
              </div>
            </div> -->




            <!-- <div v-if="incentives && incentives.length" class="mb-3">
              <p class="d-flex align-items-center">
                <span class="max_100 font-weight-bold">Incentives:</span>
              </p>
              <div v-for="(item, index) in incentives" :key="index">
                <div class="d-flex align-items-center justify-content-between mb-2">
                  <small class="max_100">
                    {{ item.programname }}
                  </small>
                  <small v-if="item.cash" class="ml-2"> ${{ item.cash }} </small>
                </div>
              </div>


            </div> -->

            <!-- <div class="mb-3 price_table">
            <p>
              <span>New MSRP Label</span> <span>$33,405</span>
            </p>
            <p>
              <span>New Discount Label</span> <span>-$1350</span>
            </p>
            <p>
              <span>Pro Pack</span> <span>+$999</span>
            </p>
            <p>
              <span>All Discount</span> <span>-$500</span>
            </p>
            <p>
              <span>Accessories</span> <span>+$500</span>
            </p>
          </div> -->
            <!-- <h1 class="font-weight-bold mb-0">$33,054</h1>
          <small class="text-black-50">Please excludes tax, tags and dealer fees. offer expires - 3/5/2025</small> -->







            <div v-if="vehicleInfo.uri" class="mt-3">
              <a class="d-inline-flex align-items-center view_all_btn rounded-buttons  bgcolor-primary text-white text-decoration-none"
                :href="vehicleInfo.uri" target="_blank">{{
                  vehicleInfo.displayName }} <i class="primaryicon-right-arrow-light pl-2"></i></a>
            </div>
          </div>
        </div>
        <div class=" text-center">
          <div class="rounded_10 img_card" v-if="vehicleInfo.vehicleImg">
            <img class="img-fluid rounded_10" :src="vehicleInfo.vehicleImg" alt="" @error="onImageError" />
          </div>
          <div v-else>
            <NoVehicle />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <TvmPreLoader />
    </div>
  </div>
</template>
<script>
import { mapState } from "pinia";
import { ExpressPaymentsBaseService } from "../../../../../../js/Common/Payments/ExpressPaymentsBaseService";
import { ExpressPayments } from "../../../../Services/Payments/ExpressPayments";
import { useIncentiveStore } from "../../../../store/IncentivesStore/IncentivesStore";
import TvmPreLoader from "../../TvmPreLoader/TvmPreLoader.vue";
import { Payments } from "../../../../Services/Payments/Payments";
import { usePaymentSettingsStore } from "../../../../store/PaymentSettings/PaymentsettingsStore";
import axios from "axios";
import { ChatWidgetService } from "../../../../Services/ChatWidgetService/ChatWidgetService";
import { isFdLincolnDealer, isFordDealer } from "../../../../Events/FordDirect/FordCookieService";
import { GET_PAYMENT_SETTINGS } from "../../../../../../store/types";

import TotalIncentiveDiscount from "../../../PaymentCalculator/TotalIncentiveDiscount/TotalIncentiveDiscount.vue";
import SimmerEffect from "./SimmerEffect.vue";
import { formatSavingsData } from "../../../../Services/Payments/PaymentsService";
import NoVehicle from "./NoVehicle.vue";

export default {
  props: ["botResponse", "isLastIndex", "chatThemeSettings"],
  data() {
    return {
      vehicleInfo: null,
      isLoading: true,
      qualifiedData: null,
      incentives: null,
      msrpDetails: null,
      customHeaderLabel: '',
      isApiLoading: false,
      settings: null,
    };
  },
  mounted() {
    this.getVehicleInfo();
  },

  methods: {
    async getVehicleInfo() {
      // this.isLoading = true;
      this.isApiLoading = true;
      this.vehicleInfo = this.botResponse?.component?.value || {};
      const { zipCode, dealerId, styleId, make, model, year, type, showConditionalRebates, showRebatesBreakoutVDP, showRebatesDetails, customHeaderLabel, vdpZip, incentiveSource, isFordDirect, conditionalRebatesBreakoutIncentivesForVDP, conditionalRebatesBreakoutIncentives, showExpandedFeesUsedVDP, showExpandedFeesNewVDP } =
        this.botResponse?.component?.value || {};
      if (this.vin) {
        try {
          // window.vdpAccountId = dealerId;

          // const url = window.fastlyESInventoryAPIBaseUrl;

          // const apiUrl = `${url}/tvm-services/inventory/vehicledetails-by-vin?AccountId=${dealerId}&CampaignId=95&Vin=${this.vin}`;

          // const vehicleDetails = await axios.get(apiUrl);
          // this.vehicleInfo = vehicleDetails;
          // this.isLoading = false;
          const paramsData = {
            vin: this.vin,
            styleId: styleId,
            accountId: dealerId,
            make: make,
            model: model,
            year: year,
            type: type,
            zipcode: zipCode,
            vdpZip: vdpZip
          };
          window.vehicleType = type;
          window.showConditionalRebates = showConditionalRebates;
          window.showRebatesBreakoutVDP = showRebatesBreakoutVDP;
          window.showRebatesDetails = showRebatesDetails;
          window.customHeaderLabel = customHeaderLabel || '';
          this.customHeaderLabel = customHeaderLabel || '';
          window.IncentiveSource = incentiveSource;
          window.isFordDirect = isFordDirect;
          window.conditionalRebatesBreakoutIncentivesForVDP = conditionalRebatesBreakoutIncentivesForVDP
          window.conditionalRebatesBreakoutIncentives = conditionalRebatesBreakoutIncentives
          window.showExpandedFeesUsedVDP = showExpandedFeesUsedVDP;
          window.showExpandedFeesNewVDP = showExpandedFeesNewVDP

          try {
            window.vin = this.vin;
            window.aiCall = true;
            let response = await axios.get(
              `${window.ApiBaseUrl}/Inventory/getPaymentSettingDetails?accountId=${dealerId}&vin=${this.vin}&styleid=${styleId}`
            );
            this.settings = response.data;

            // const data = Payments.getMsrpDetails(this.settings, "cash");
            // console.log("git msrp details");
            // console.log(data);


            // this[GET_PAYMENT_SETTINGS](response.data);

            Payments.getPayments(0, 0, '', 0, '', 0, 0).then(async (response) => {
              console.log(response, "paymentsData");
              let leasefinancedata = Payments.formatPayments(response, '', this.settings);

              let financedata = '';
              let paymentsFeesData = '';
              let feesResults = await Payments.getFeesResults();
              if (feesResults) {
                console.log(feesResults)
              }

              if (leasefinancedata?.length) {
                financedata = leasefinancedata[1][0];
              }
              if (response.FeesAndTaxesCollection) {
                paymentsFeesData = response.FeesAndTaxesCollection;
              }




              const data = Payments.getMsrpDetails(this.settings, "cash", financedata, feesResults, paymentsFeesData, true);
              // this.msrpDetails = data;
              this.msrpDetails = formatSavingsData(data.totalSavingsData);
              if (this.msrpDetails) {
                this.msrpDetails = this.msrpDetails.flat();
              }
              console.log(this.msrpDetails, "msrpDetails");
              this.isApiLoading = false;
            })
            // console.log(paymentsFeesData, "paymentsFeesData");



            this.qualifiedData = await ChatWidgetService.getConditionalRebates(paramsData);
            console.log(this.qualifiedData, "incentivesData");

            this.IncentivesData();
          } catch (e) {
            console.log(e);
            this.isApiLoading = false;
          }

          // const paymentSettingsStore = usePaymentSettingsStore();
          // paymentSettingsStore.setpaymentsettings(paramsData);
        } catch (err) {
          console.log(err);
          // this.isLoading = false;
          this.isApiLoading = false;
        }
      }

      // const incentives = await ExpressPaymentsBaseService.getSpecialIncentives('cash', zipCode);

      // console.log(this.setFordDirectQualifiedIncentives, 'incentives');
    },
    getVehicleIntExteriorColorStyle(colorHexCode, colorGeneric) {
      if (colorHexCode === "" && colorGeneric === "") {
        return {
          "background-color": "transparent",
          border: "1px solid #ccc",
        };
      }

      const color = colorHexCode ? `#${colorHexCode}` : colorGeneric;
      return { "background-color": `${color} !important`, "border-color": `${color} !important` };
    },
    formatIncentiveData(data) {
      const incentives = data.map((t) => {
        let cashValue = isFordDealer(window.IncentiveSource) ? +t.amount : +t.cash;
        return {
          ...t,
          programname: isFordDealer(window.IncentiveSource) ? t.namedetailed : t.specialprogramname,
          cash: cashValue,
          incentiveid: isFordDealer(window.IncentiveSource)
            ? t.incentiveid
            : t.specialprogramname + t.offertype,
        };
      });
      if (isFdLincolnDealer(window.IncentiveSource)) {
        this.incentives = incentives.filter(
          (i) => i.offertype.toLowerCase() === "all" || i.offertype.toLowerCase() === "cash"
        );
      } else {
        this.incentives = incentives;
      }
      //showing incentives in descending order
      this.incentives = this.incentives.sort((a, b) => {
        return b.cash - a.cash;
      });
    },
    IncentivesData() {
      let incentiveData =
        this.qualifiedData && typeof this.qualifiedData === "string"
          ? JSON.parse(this.qualifiedData)
          : this.qualifiedData;

      if (incentiveData && incentiveData.length) {
        const lowerize = (obj) =>
          Object.keys(obj).reduce((acc, k) => {
            acc[k.toLowerCase()] = obj[k];
            return acc;
          }, {});

        incentiveData = incentiveData.map((t) => {
          return { ...lowerize(t) };
        });
        this.formatIncentiveData(incentiveData);
      }
    },
    onImageError(event) {
      event.target.src = '../../../../../../images/chat-widget/no-vehicle-image.png'
    }
  },
  computed: {
    vin() {
      return this.botResponse?.component?.value?.vin || "";
    },
    vehicleDisplayName() {
      if (!this.vehicleInfo) {
        return "";
      }
      const { year, make, model, trim } = this.vehicleInfo;
      return [year, make, model, trim].filter(Boolean).join(" ");
    },
    IncentiveStore() {
      return useIncentiveStore();
    },
    // ...mapState(usePaymentSettingsStore, [GET_PAYMENT_SETTINGS, "gotpayments", "settings"]),
  },
  components: {
    TvmPreLoader,
    TotalIncentiveDiscount,
    SimmerEffect,
    NoVehicle
  },
  watch: {
    // gotpayments() {
    //   if (this.gotpayments) {
    //     const data = Payments.getMsrpDetails(this.settings, "cash");
    //     console.log("git msrp details");
    //     console.log(data);
    //     this.isApiLoading = false;
    //     this.msrpDetails = data;
    //   }
    // },
  },
};
</script>
<style scoped>
.ai_vehicle_info {
  max-width: fit-content;
  padding: 30px;
}

.gap_60 {
  gap: 60px;
}

.ai_vehicle_info h1 {
  font-size: 1.7rem !important;
}

.ai_vehicle_info p {
  margin-bottom: 3px;
}

.price_table {
  max-width: 400px;
}

.price_table p {
  display: flex;
  justify-content: space-between;
}

.img_card img {
  max-height: 400px;
  display: block;
  /* float: right; */
}

.max_100 {
  min-width: 100px;
  display: inline-block;
}

.color-box {
  width: 15px;
  height: 15px;
  border: 1px solid #ccc;
  border-radius: 50%;
}

.incentives_box {
  max-width: 500px;
}

.view_all_btn {
  padding: 10px 20px;
}

.msrp_details_box {
  max-width: fit-content;
}

.ai_vehicle_info .custom_font_size span {
  font-size: 2.5rem !important;
}

.p_x_60 {
  padding: 0 60px;
}
</style>
